import Member from './member';
import TransactionSetType from './transactionSetType';

export default class Pay1SyncHoldErrorOverview {
  subscriberMemberId: string;
  lastName: string;
  firstName: string;
  errorDate: Date;
  program: string;
  agency: string;
  tranIds: number[];
  createdDate: Date;

  constructor(source?) {
    if (source) {
      this.subscriberMemberId = source.subscriberMemberId;
      this.lastName = source.lastName;
      this.firstName = source.firstName;
      this.errorDate = new Date(source.errorDate);
      this.program = source.program;
      this.agency = source.agency;
      this.tranIds = source.tranIds;
      this.createdDate = new Date(source.createdDate);
    }
  }

  public get errorCount(): number {
    if (this.tranIds && this.tranIds.length > 0)
      return this.tranIds.length;

    return 0;
  }
}
